import { UpdateSubRecipeDetailsRawProductsResponse } from "../../../services/subrecipe/subrecipe.types";
import Table from "../../../components/Table/Table";
import { FC } from "react";

interface SubRecipeRawProductUpdatesTableProps {
  updates: UpdateSubRecipeDetailsRawProductsResponse[]
}

const SubRecipeRawProductUpdatesTable: FC<SubRecipeRawProductUpdatesTableProps> = (
    {
      updates
    }
) => {
  return (
      <Table
          showHeader={true}
          headerTitle="Review"
          rowData={updates}
          returnedRecords={updates.length}
          columnDefs={[
            {
              minWidth: 80,
              initialFlex: 2,
              headerName: 'Spec',
              valueGetter: (row: any) => {
                let { specNo, description } = row.data.spec;
                return `${specNo} ~ ${description}`;
              }
            },
            {
              minWidth: 80,
              initialFlex: 1,
              headerName: 'Sub-Spec',
              field: 'subSpec'
            },
            {
              minWidth: 80,
              initialFlex: 2,
              headerName: 'Current Raw Product',
              valueGetter: (row: any) => {
                let { moaRawProdNo, moaRawProdDesc } = row.data.oldRawProduct;
                return `${moaRawProdNo} ~ ${moaRawProdDesc}`;
              }
            },
            {
              minWidth: 80,
              initialFlex: 1,
              headerName: 'Current Usage Amount',
              field: 'oldUsageAmount'
            },
            {
              width: 50,
              valueGetter: () => '→',
              floatingFilter: false,
              sortable: false
            },
            {
              minWidth: 80,
              initialFlex: 2,
              headerName: 'Desired Raw Product',
              valueGetter: (row: any) => {
                let { moaRawProdNo, moaRawProdDesc } = row.data.newRawProduct;
                return `${moaRawProdNo} ~ ${moaRawProdDesc}`;
              }
            },
            {
              minWidth: 80,
              initialFlex: 1,
              headerName: 'Desired Usage Amount',
              field: 'newUsageAmount'
            }
          ]}
      />
  )
}

export default SubRecipeRawProductUpdatesTable;